import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { cookieAttributes } from "util/resumeCookieSettings";
import { Breadcrumbs } from "features/breadcrumb/breadcrumbs";
import classes from "../Dashboard.module.scss";
import { DashboardsEmbedWrapper } from "../DashboardVisualization/dashboardEmbed";

function PhysicianNeedAssessmentPage(props) {
  const dashboardId = props?.match?.params?.dashboardId?.trim();

  const breadCrumbsItems = [
    { label: "Home", to: "/" },
    { label: "Physician Needs Assessment" }
  ];

  useEffect(() => {
    if (dashboardId) {
      async function setResumeCookie() {
        const cookieValue = encodeURIComponent(
          `Physician Needs Assessment - /physicianneedassessment/${dashboardId}`
        );
        const resumeCookie = Object.assign(
          cookieAttributes(),
          { name: "platform_resume" },
          { value: cookieValue }
        );
        await cookieStore.set(resumeCookie);
      }
      setResumeCookie();
    }
  }, [dashboardId]);

  return (
    <div className={`query-wrapper ${classes["dashboard-wrapper"]}`}>
      <Breadcrumbs items={breadCrumbsItems} />
      <div className={classes["head-wrapper"]}>
        <div>
          <h3 className={classes["heading"]}>Physician Needs Assessment</h3>
          <span className={classes["subtitle"]}>
            Evaluate current and future physician supply across your service area to identify specialty gaps and priority shortages.
          </span>
        </div>
      </div>
      <div>
        {dashboardId ? (
          <DashboardsEmbedWrapper dashboardId={dashboardId} />
        ) : (
          <div className="alert alert-warning">No dashboard specified</div>
        )}
      </div>
    </div>
  );
}

PhysicianNeedAssessmentPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      dashboardId: PropTypes.string
    })
  })
};

export default PhysicianNeedAssessmentPage;
